import React from 'react';
import { Button, Tab, Responsive } from 'semantic-ui-react';
import PreviousCertificates from './PreviousCertificates';
import NewStudentCertificate from './NewStudentCertificate';


export default class StudentCertificates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            limitation: this.props.limitation,
        };
    }


    render() {
        const panes = [
            (localStorage.getItem('activeRole').substr(0, 10) === 'Studentska') ? {
            // (localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' && !this.state.limitation) ? {
                menuItem: 'Izdavanje dokumenata',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <NewStudentCertificate />

                </Tab.Pane>)
            } : null,
            {
                menuItem: 'Izdati dokumenti',
                render: () => (<Tab.Pane attached={false} as={Responsive} >
                    <PreviousCertificates
                        studentId={this.props.studentId}
                        studyProgramId={this.props.studyProgramId}
                    />
                </Tab.Pane>)
            }

        ];


        return (
            <div>
                <Tab
                    panes={panes}
                    menu={{
                        secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                    }}
                    defaultActiveIndex={(localStorage.getItem('activeRole').substr(0, 10) === 'Studentska') ? 0 : 1}
                    // defaultActiveIndex={(localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' && !this.state.limitation) ? 0 : 1}
                    grid={{ paneWidth: 13, tabWidth: 3 }}
                />
            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentCertificates.js